import Carousel from '../../components/base/Carousel';
import Popup from '../../components/base/Popup';

/**
 * Инициализация карусели "Программа ухода"
 * И карточек внутри неё
 */
export default () => {
    $(document).on('click', '.js-product-picture-link', function() {
        const variantId = $(this).data('variant-id');
        const $popup = $(`#popup-product-pic-fullscreen-${variantId}`);
        const popupInstance = Popup.getInstance($popup);
        const $carouselPicFullScreen = $popup.find('.carousel--picture-fullscreen');
        const carouselPictureFullscreen = new Carousel($carouselPicFullScreen);

        $carouselPicFullScreen.addClass('is-loading');
        popupInstance.open();

        // Инициализация карусели
        carouselPictureFullscreen.init({});

        // При каждом открытии обновляем карусель
        popupInstance.afterShow = () => {
            setTimeout(() => {
                carouselPictureFullscreen.instance.update();
                $carouselPicFullScreen.removeClass('is-loading');
            }, 200);
        };
    });
};
